<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-viatic'].refresh()"
    >
      <template #buttons>
        <kendo-datepicker
          class="rounded form-control"
          :min="minDate"
          :max="maxDate"
          v-model="initDateSelect"
          :format="'MM/dd/yyyy'"
          name="created_date"
          id="created_date"
        ></kendo-datepicker>
        <kendo-datepicker
          class="rounded form-control ml-1 mr-2"
          :min="minDate"
          :max="maxDate"
          v-model="endDate"
          :disabled="true"
          :format="'MM/dd/yyyy'"
          name="created_date"
          id="created_date"
        ></kendo-datepicker>
        <!--  <b-button variant="primary" class="btn-icon rounded-circle mr-1">
          <feather-icon icon="ChevronLeftIcon" />
        </b-button>
        <b-button variant="primary" class="btn-icon rounded-circle">
          <feather-icon icon="ChevronRightIcon" />
        </b-button> -->
        <b-button
          variant="info"
          v-b-tooltip.hover.top="'Download Excel'"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" />
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-monitoring-viatic"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative bord"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="showFields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(personal_name)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon
                  v-if="data.item.personal_type == 'Driver'"
                  icon="TruckIcon"
                  size="22"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="22"
                  class="text-success"
                />
              </div>
              <div class="ml-1">
                <span> {{ data.item.personal_name | capitalize }} </span>
                <br />
                <span style="opacity: 0.5"> #{{ data.item.code }} </span>
              </div>
            </div>
          </template>
          <template #cell(ut_type)="data">
            <span v-if="data.value">
              {{ ut_types.find((x) => x.id == data.value).value }}
            </span>
            <span v-else> - </span>
          </template>
          <template #cell(is_viatic)="data">
            <b-badge
              pill
              :variant="`light-${data.value == 'Apply' ? 'success' : 'danger'}`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(entity_group_name)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(viatic_status)="data">
            <b-badge
              pill
              :variant="`${
                data.value == 'REGISTERED' ? 'light-dark' : 'light-success'
              }`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(monday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'monday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(tuesday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'tuesday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(wednesday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'wednesday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(thursday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'thursday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(friday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'friday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(saturday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'saturday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(sunday)="data">
            <span
              @click="insertPersonalAttendance(data.item, 'sunday')"
              class="cursor-pointer"
              v-b-tooltip.hover.top="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>
          <template #cell(viatic_amount)="data">
            <span> S/ {{ data.value | currency }} </span>
          </template>
          <template #cell(actions)="data">
            <feather-icon
              v-if="status_viatic == 1 && validApproveVatic(data.item)"
              icon="CheckSquareIcon"
              size="20"
              class="text-success"
              v-b-tooltip.hover.right="'Approve Viatic'"
              @click="approveViatic(data.item)"
            />
          </template>
          <template #custom-foot>
            <tr
              class="sticky-data"
              :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'"
            >
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-center">
                <span class="font-weight-bolder">Subtotal</span>
              </td>
              <td
                :class="
                  isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'
                "
                :colspan="2"
              >
                <span class="text-success"> S/.{{ subtotal | currency }}</span>
              </td>
            </tr>
            <tr
              class="sticky-data"
              :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'"
            >
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-center">
                <span class="font-weight-bolder">Total</span>
              </td>
              <td
                :class="
                  isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'
                "
                :colspan="2"
              >
                <span class="text-success"> S/.{{ total | currency }}</span>
              </td>
            </tr>
          </template>
        </b-table>
      </template>
    </filter-slot>
    <!-- <b-button @click="process">Process</b-button>
    <b-button @click="send">Send</b-button>
    <pre>
      {{ items }}
    </pre> -->
    <!-- <b-table :items="items" small responsive> </b-table> -->

    <PersonalAttendance
      v-if="personalAttendance"
      :dataModal="dataModal"
      @hideModal="hidePersonalAttendance"
    />

    <ViaticApproveModal
      v-if="viaticApproveModal"
      :dataModal="dataModal"
      @hideModal="hideViaticApprove"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/monitoring/views/viatic/data/fields.data.js";
import Filters from "@/views/monitoring/views/viatic/data/filters.data.js";
// import Usuarios from "./detalle_operacion.json";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

/* Modals */
import AttendanceDetailsByStatus from "@/views/monitoring/views/attendance/components/modals/AttendanceDetailsByStatus.vue";
import PersonalAttendance from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";
import ViaticApproveModal from "@/views/monitoring/views/viatic/components/modals/ViaticApproveModal.vue";

/* Services */
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  components: {
    FilterSlot,
    AttendanceDetailsByStatus,
    PersonalAttendance,
    ViaticApproveModal,
  },
  props: {
    status_viatic: {
      require: true,
    },
  },
  data() {
    return {
      filters: Filters,
      // items: Usuarios,
      params: 1,
      fields: [],
      isBusy: false,
      ut_types: [
        { id: 1, value: "Camion Carreta" },
        { id: 2, value: "C - Camión" },
        { id: 3, value: "TS - Tracto Semiremolque" },
        { id: 4, value: "CR - Camión Remolque" },
      ],
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      initDateSelect: "",
      viaticApproveModal: false,
      personalAttendance: false,
      dataModal: {},
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      weekly: "",
      total: 0,
      subtotal: 0,
    };
  },
  computed: {
    getFields() {
      let fields = Fields.map((row) => ({
        ...row,
        label: this.$t(row.label),
      }));
      return fields;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    showFields() {
      let fieldss = this.getFields;
      fieldss.map((row) => (row.visible = true));
      fieldss[3].visible = false;
      if (this.status_viatic == 2) {
        fieldss[14].visible = false;
      }
      if (this.currentUser.role_id != 1) {
        fieldss[13].visible = false;
        fieldss[14].visible = false;
      }
      let fieldsVisible = fieldss.filter((item) => item.visible);
      fieldsVisible[5].label = this.$t("mon").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(1, "days")
            .format("MM-DD")
      );
      fieldsVisible[6].label = this.$t("tue").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(2, "days")
            .format("MM-DD")
      );
      fieldsVisible[7].label = this.$t("wed").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(3, "days")
            .format("MM-DD")
      );
      fieldsVisible[8].label = this.$t("thu").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(4, "days")
            .format("MM-DD")
      );
      fieldsVisible[9].label = this.$t("fri").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(5, "days")
            .format("MM-DD")
      );
      fieldsVisible[10].label = this.$t("sat").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(6, "days")
            .format("MM-DD")
      );
      fieldsVisible[11].label = this.$t("sun").concat(
        " " +
          moment(this.initDateSelect)
            .startOf("week")
            .add(7, "days")
            .format("MM-DD")
      );
      return fieldsVisible;
    },
  },
  created() {
    this.initDateSelect = this.initDate;
    this.getEntityGroups();
  },
  methods: {
    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          personal_type:
            this.filters[0].model != null ? this.filters[0].model : 2,
          is_viatic: this.filters[1].model != null ? this.filters[1].model : 0,
          entity_group_id:
            this.filters[2].model != null ? this.filters[2].model : 0,
          start_date: this.initDate,
          final_date: this.endDate,
          status: this.filters[3].model != null ? this.filters[3].model : 1,
          status_viatic: this.status_viatic,
        };
        const { data } = await ViaticService.getWeeklyViatics(params);

        this.total = data.data[0].total;

        this.subtotal = 0;

        data.data.map((row) => {
          this.subtotal += row.viatic_amount;
        });

        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async exportToExcel() {
      try {
        this.addPreloader();
        const params = {
          search_txt: this.filterPrincipal.model,
          personal_type:
            this.filters[0].model != null ? this.filters[0].model : 2,
          is_viatic: this.filters[1].model != null ? this.filters[1].model : 0,
          entity_group_id:
            this.filters[2].model != null ? this.filters[2].model : 0,
          start_date: this.initDate,
          final_date: this.endDate,
          status: this.filters[3].model != null ? this.filters[2].model : 1,
          status_viatic: this.status_viatic,
          type: "export",
          fields: JSON.stringify(this.showFields),
        };
        const { data } = await ViaticService.exportToExcel(params);
        this.forceFileDownload(data, "report.xlsx");
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getEntityGroups() {
      const { data } = await EmployeeService.getEntitiesGroup();
      this.filters = Filters;
      this.filters[2].options = data;
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id == null) return "default";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
    countHomeworkStatusVariant(count) {
      if (count === 0) return "success";
      if (count > 0 && count <= 3) return "warning";
      return "danger";
    },
    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
    async insertPersonalAttendance(item, day) {
      // if (this.isCeo || this.isChief || this.currentUser.role_id == 4) {
      if (this.isCeo || this.isChief) {
        try {
          this.addPreloader();
          const params = {
            date: item[day].date,
            attendance_id: item.id,
          };
          const { data } = await ViaticService.validateApprovedAttendance(
            params
          );
          this.dataModal = {
            id: item.id,
            id_detail: item[day].id,
            code: item.code,
            personal_name: item.personal_name,
            date: item[day].date,
            homework_status_id: item[day].homework_status_id || null,
            observation: item[day].observation || null,
            comment: item[day].comment || null,
            origin: "viatic",
            approved: data.isApproved,
            attendance_status_viatic_id: data.att?.attendance_status_viatic_id,
            payroll_id: data.att?.payroll_id,
          };
          this.personalAttendance = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.removePreloader();
        }
      } else {
        this.showToastWarning("Usuario no autorizado");
      }
    },
    hidePersonalAttendance(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-viatic"].refresh();
      }
      this.personalAttendance = false;
    },
    async approveViatic(item) {
      const keys = this.showFields;
      item.monday.key = keys[6].label;
      item.tuesday.key = keys[7].label;
      item.wednesday.key = keys[8].label;
      item.thursday.key = keys[9].label;
      item.friday.key = keys[10].label;
      item.saturday.key = keys[11].label;
      item.sunday.key = keys[12].label;
      const attend_ids = [
        item.monday,
        item.tuesday,
        item.wednesday,
        item.thursday,
        item.friday,
        item.saturday,
        item.sunday,
      ];
      this.dataModal = {
        code: item.code,
        start_date: item.monday.date,
        end_date: item.sunday.date,
        personal_name: item.personal_name,
        personal_id: item.personal_id,
        start_date: item.monday.date,
        end_date: item.sunday.date,
        is_viatic: item.is_viatic,
        viatic_amount: item.viatic_amount,
        attend_ids: JSON.stringify(attend_ids),
      };
      this.viaticApproveModal = true;
    },
    hideViaticApprove(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-viatic"].refresh();
      }
      this.viaticApproveModal = false;
    },
    validApproveVatic(item) {
      if (
        item.monday.homework_status_id != undefined &&
        item.tuesday.homework_status_id != undefined &&
        item.wednesday.homework_status_id != undefined &&
        item.thursday.homework_status_id != undefined &&
        item.friday.homework_status_id != undefined &&
        item.saturday.homework_status_id != undefined &&
        item.sunday.homework_status_id != undefined
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    initDateSelect(newVal, oldVal) {
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");

      this.getFields[6].label =
        this.$t("mon") +
        " " +
        moment(newVal).startOf("week").add(1, "days").format("MM-DD");
      this.getFields[7].label =
        this.$t("tue") +
        " " +
        moment(newVal).startOf("week").add(2, "days").format("MM-DD");
      this.getFields[8].label =
        this.$t("wed") +
        " " +
        moment(newVal).startOf("week").add(3, "days").format("MM-DD");
      this.getFields[9].label =
        this.$t("thu") +
        " " +
        moment(newVal).startOf("week").add(4, "days").format("MM-DD");
      this.getFields[10].label =
        this.$t("fri") +
        " " +
        moment(newVal).startOf("week").add(5, "days").format("MM-DD");
      this.getFields[11].label =
        this.$t("sat") +
        " " +
        moment(newVal).startOf("week").add(6, "days").format("MM-DD");
      this.getFields[12].label =
        this.$t("sun") +
        " " +
        moment(newVal).startOf("week").add(7, "days").format("MM-DD");
      var a = moment(newVal).startOf("week").add(1, "days");
      var b = moment().startOf("week").add(1, "days");
      this.week = a.diff(b, "weeks");
      // this.getModuleUsers();
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}
.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}
.k-widget.form-control .k-input {
  height: 2.5rem !important;
}

.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}
</style>